module.exports = ".error-message{color:#e74c3c}.result-list{max-height:10em;overflow-y:scroll}.result-row{color:#789;margin-bottom:.33em}";